<button type="button" class="setup-cta" (click)="onSetupTeam()">
  <span class="cta-label">Set Up Your Team</span>
  <span class="cta-arrow" aria-hidden="true">→</span>
</button>
